<template>
    <div class="swiper">
        <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(ranking, index) in rank_list" :key="index">
                <a :data-cy="`slide-item-${index}`"
                 :href="route(route_list, 'site.item.detail.gravure', {item_detail_url:ranking.item.ITEM_DETAIL_URL})">
                    <div class="c-slider-normal__img">
                        <webp-picture :webp="ranking.item.thumbnail_webp_file_path" class="inherit">
                            <img :src="ranking.item.thumbnail_file_path" alt="" loading="lazy">
                        </webp-picture>
                    </div>
                    <div class="label-container">
                        <div v-if="ranking.item.is_new == true" class="c-label is-new">New</div>
                        <div class="c-label is-photos">写真集</div>
                        <div v-if="ranking.item.has_extra_item == 1" class="c-label is-limited">限定特典付</div>
                    </div>
                    <div class="c-book-block__wrapper">
                        <p class="c-booktitle u-text-ellipsis has-2-lines">{{ ranking.item.item_description.ITEM_TITLE }}</p>
                    </div>
                    <div class="c-book-block__wrapper">
                        <p class="c-bookname u-text-ellipsis has-2-lines">{{ ranking.item.talent_names }}</p>
                    </div>
                </a>
                <div v-if="ranking.item.BROWSER_VIEW_PARAM" class="c-round-btn is-positive is-transparent">
                    <a class="is-blue" :href="route(route_list, 'site.item.sample', {item_detail_url: ranking.item.ITEM_DETAIL_URL})" target="_blank">立ち読み</a>
                </div>
            </div>
        </div>
        <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow">
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
export default {
    props: [
        'rank_list',
        'route_list'
    ],
    mixins: [routeMixin],
}
</script>

<style scoped>
.swiper {
    width: 100%;
}
.slide-arrow {
    top: 130px;
}

.label-container {
    min-height: 42px;
    display: flex;
    flex-wrap: wrap;
}

.c-booktitle {
    margin: 0;
    color: var(--gj-text-color-light);
    text-align: start;
    word-break: break-all;
}

.c-bookname {
    margin: 0;
    text-align: start;
    align-items: center;
    line-height: 18.2px;
}

.c-book-block__wrapper {
    display: flex;
    align-items: center;
    &:has(.c-booktitle) {
        min-height: 32px;
    }
    &:has(.c-bookname) {
        min-height: 37px;
        margin-bottom: 8px;
    }
}
</style>
